import React from 'react';
import PropTypes from 'prop-types';
import { AppBar, Fab, Toolbar, Typography } from '@material-ui/core';
import { Opacity } from '@material-ui/icons';
// eslint-disable-next-line import/no-unresolved
import Img from 'react-image';
import RepsLogo from '../../images/reps.png';
import styles from './styles';

const Footer = ({ switchThemeMode }) => {
  const classes = styles();
  const dt = new Date();
  const currentYear = dt.getFullYear();

  return (
    <AppBar position="static" color="primary" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Typography color="inherit">{`© 2017-${currentYear} REPS & Co / Konami.`}</Typography>
        <Typography color="inherit">
          <span>
            &nbsp;You&nbsp;are&nbsp;using&nbsp;the&nbsp;
            <i>best&nbsp;broker&nbsp;tool</i>
            &nbsp;in&nbsp;the&nbsp;
            <strong>world</strong>
            <span>. ™</span>
          </span>
        </Typography>
        <Fab color="primary" aria-label="Opacity" className={classes.fabButton} onClick={switchThemeMode} size="small">
          <Opacity />
        </Fab>
        <div className={classes.grow} />
        <div style={{ overflow: 'hidden' }}>
          <Img src={RepsLogo} style={{ padding: '10px 0', verticalAlign: 'bottom', height: '45px' }} />
        </div>
      </Toolbar>
    </AppBar>
  );
};

Footer.propTypes = {
  switchThemeMode: PropTypes.func.isRequired,
};

export default Footer;
